import * as yup from 'yup'
import { PersonDto } from './personDto'

export class VehicleBondNoteDto {
  id?: string = undefined
  user?: string = undefined
  sentToEmail?: PersonDto = undefined
  sentDateTime?: string = undefined
}

export const VehicleBondNoteValidationSchema = yup.object({
  note: yup.string().max(200, 'Bond Notes cannot be more than 200 characters').nullable()
})
